'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _translate = require('../../language/translate');

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */
exports.default = function (values, props) {
  var removeMembershipField = props.removeMembershipField;

  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !applicant.email,
        additional_data: {
          relationship_to_primary_applicant: i > 0 && !applicant.additional_data.relationship_to_primary_applicant
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date,
      expiry_date: !values.application.expiry_date,
      additional_data: _extends({
        eligibility: !values.application.additional_data.eligibility,
        trip_booked_date: !values.application.additional_data.trip_booked_date,
        cancel_delux: !values.application.additional_data.cancel_delux,
        country_of_origin: !values.application.additional_data.country_of_origin,
        destination: values.application.additional_data.country_of_origin === 'CA' && !values.application.additional_data.destination,
        province_of_residence: ['CA', 'US'].includes(values.application.additional_data.country_of_origin) && !values.application.additional_data.province_of_residence,
        trip_cost: !values.application.additional_data.trip_cost || values.application.additional_data.trip_cost && values.application.additional_data.trip_cost.replace(/\$/g, '').replace(/,/g, '') > 30000
      }, !removeMembershipField && { membership_number: !values.application.additional_data.membership_number })
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/association/Quote.js
// module id = 1768
// module chunks = 0